import { Link } from "react-router-dom";

function LandingPage() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg,#4f46e5,#06b6d4)",
      color: "white",
      fontFamily: "Arial"
    }}>

      {/* Navbar */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "20px 40px",
        alignItems: "center"
      }}>
        <h2>🛡 Digital Afterlife</h2>

        <div>
          <Link to="/login">
            <button style={{
              marginRight:"10px",
              padding:"8px 16px",
              background:"white",
              color:"#4f46e5",
              border:"none",
              borderRadius:"6px",
              fontWeight:"bold",
              cursor:"pointer"
            }}>
              Login
            </button>
          </Link>

          <Link to="/register">
            <button style={{
              padding:"8px 16px",
              background:"white",
              color:"#4f46e5",
              border:"none",
              borderRadius:"6px",
              fontWeight:"bold",
              cursor:"pointer"
            }}>
              Register
            </button>
          </Link>
        </div>
      </div>


      {/* Hero Section */}
      <div style={{
        textAlign: "center",
        marginTop: "120px",
        padding:"0 20px"
      }}>

        <h1 style={{
          fontSize:"70px",
          fontWeight:"bold"
        }}>
          FINAL TRACE
        </h1>

        <p style={{
          fontSize:"20px",
          marginTop:"20px",
          maxWidth:"700px",
          margin:"20px auto"
        }}>
          Plan what happens to your digital accounts after you're gone.
          Assign a trusted executor and securely manage your digital legacy.
        </p>

        <div style={{marginTop:"40px"}}>

          {/* Get Started Button */}
          <Link to="/register">
            <button style={{
              padding:"14px 32px",
              marginRight:"20px",
              fontSize:"16px",
              background:"white",
              color:"#4f46e5",
              border:"none",
              borderRadius:"8px",
              cursor:"pointer",
              fontWeight:"bold",
              boxShadow:"0 4px 10px rgba(0,0,0,0.2)"
            }}>
              Get Started
            </button>
          </Link>

          {/* Sign In Button */}
          <Link to="/login">
            <button style={{
              padding:"14px 32px",
              fontSize:"16px",
              background:"#0ea5e9",
              color:"white",
              border:"none",
              borderRadius:"8px",
              cursor:"pointer",
              fontWeight:"bold"
            }}>
              Sign In
            </button>
          </Link>

        </div>

      </div>

    </div>
  );
}

export default LandingPage;